import { common } from '@kurtosys/ksys-app-template';

import { IBreakpointProps } from '../models/IBreakpointProps.js';
import { IComponentBaseConfiguration } from '../models/IComponentBaseConfiguration.js';
import { IComponentBaseState } from '../models/IComponentBaseState.js';
import { IResponsiveComponentBaseProps } from '../models/IResponsiveComponentBaseProps.js';

import { ComponentBase } from './ComponentBase.js';

export abstract class ResponsiveComponentBase<
	TProps extends IResponsiveComponentBaseProps<TProps>,
	TState extends IComponentBaseState,
	TConfiguration extends IComponentBaseConfiguration,
> extends ComponentBase<TProps, TState, TConfiguration> {
	get breakpoints(): IBreakpointProps<TProps>[] {
		const { breakpoints: breakpointsFromProps = [] } = this.props;
		let response: IBreakpointProps<TProps>[] = [];
		if (!breakpointsFromProps || breakpointsFromProps.length === 0) {
			response = [
				{
					size: 'xsmall',
					modifier: 'up',
					props: this.props,
				},
			];
		} else {
			response = breakpointsFromProps.map((breakpointProps) => {
				return common.commonUtils.deepMergeObjects({ props: this.props }, breakpointProps);
			});
		}
		return response;
	}

	getBreakpointComponentProps(breakpoint: IBreakpointProps<TProps>, breakpointIndex: number): object {
		const { size, modifier } = breakpoint;
		const breakpointProps = {
			key: breakpointIndex,
			[size]: true,
			[modifier]: true,
		};
		return breakpointProps;
	}
}
